import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class AiQuestionCriteria extends BasicCriteria {
visionCode: string;
}

